import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMq from 'vue-mq'

import 'purecss/build/pure-min.css'
import 'purecss/build/grids-responsive.css'
import 'highlight.js/styles/docco.css';

Vue.config.productionTip = false

Vue.use(VueMq, {
  breakpoints: {
    sm: 568,
    md: 768,
    lg: 1024,
    xl: Infinity
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
